import { Component, EventEmitter, HostListener, OnInit, Output, OnDestroy, ChangeDetectorRef, AfterViewInit, AfterContentChecked } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ActionsAnalyticsService, MobileCustomPlansServiceNoSync, MobilePlanItem } from '@ztarmobile/zwp-service-backend';
import { takeWhile } from 'rxjs/operators';
import { PLANS_SHOP_ROUTE_URLS, ROUTE_URLS, SHOP_ROUTE_URLS, SUPPORT_ROUTE_URLS } from '../../../app.routes.names';
import { ContentfulService } from 'src/services/contentful.service';
import Swiper, { EffectFade, Keyboard, Navigation, Pagination, SwiperOptions } from 'swiper';
import { CUSTOMER_CARE_NUMBER, WEBSITE_URL } from '@env/environment';
import { BRAND } from '@app/app.config';
import { TERMS_AND_CONDITIONS_ROUTE_URLS } from '@app/support/terms-and-conditions/terms-and-conditions.routesName';
import { PhonePipe } from '@widgets/pipes/phone.pipe';
import { FadeInOutAnimation } from '@app/app.animations';
import { ProductPlansService } from '@ztarmobile/zwp-service-backend-v2';
import { ToastrHelperService } from '@services/toast-helper.service';
import { IProductPlanInfo } from '@ztarmobile/zwp-service-backend-v2/lib/models';

const SUBSCIPTION_DURATIONS = {
    ONE_MONTH: 1,
    THREE_MONTHS: 3,
    SIX_MONTHS: 6,
    ONE_YEAR: 12
};
@Component({
    selector: 'app-plans-layout-a',
    templateUrl: './plans-layout-a.component.html',
    styleUrls: ['./plans-layout-a.component.scss'],
    animations: [FadeInOutAnimation],
})

export class PlansLayoutAComponent implements OnInit, OnDestroy, AfterViewInit {
    @Output() addPlanToCart: EventEmitter<MobilePlanItem> = new EventEmitter<MobilePlanItem>();
    public changeMessage = false;
    public expandPlans = false;
    public innerWidth;
    public filteredPlans: Array<MobilePlanItem>;
    public monthlyPlans: Array<MobilePlanItem>;
    public quarterlyPlans: Array<MobilePlanItem>;
    public halfYearPlans: Array<MobilePlanItem>;
    public yearlyPlans: Array<MobilePlanItem>;
    public SUBSCIPTION_DURATIONS = SUBSCIPTION_DURATIONS;
    public plansConfig: SwiperOptions = {
        direction: 'horizontal',
        keyboard: false,
        mousewheel: false,
        scrollbar: false,
        centeredSlides: true,
        roundLengths: true,
        loopFillGroupWithBlank: true,
        slideToClickedSlide: true,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 'auto',
        initialSlide: 1,
        observer: true,
        observeParents: true,
        effect: 'slide',
        updateOnWindowResize: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        pagination: {
            el: '.slider-pagination',
            renderBullet: (index, className) => `<li style="z-index: 10" class="slick-active ${className}"><button ></button></li>`,
            clickable: true
        },
        spaceBetween: 0
    };
    public testimonialsConfig: SwiperOptions = {
        direction: 'horizontal',
        keyboard: false,
        mousewheel: false,
        scrollbar: false,
        roundLengths: true,
        loopFillGroupWithBlank: true,
        slideToClickedSlide: true,
        initialSlide: 1,
        observer: true,
        navigation: {
            nextEl: '.testimonial-swiper-button-next',
            prevEl: '.testimonial-swiper-button-prev'
        },
        spaceBetween: 0,
        breakpoints: {
            320: { //min-width
                slidesPerView: 1,
                centeredSlides: false
            },
            640: {
                slidesPerView: 'auto',
                centeredSlides: true
            }
        }
    };
    public subscriptionCycles = [
        SUBSCIPTION_DURATIONS.ONE_MONTH,
        SUBSCIPTION_DURATIONS.THREE_MONTHS,
        SUBSCIPTION_DURATIONS.SIX_MONTHS,
        SUBSCIPTION_DURATIONS.ONE_YEAR
    ];
    public selectedSubscription = SUBSCIPTION_DURATIONS.THREE_MONTHS;
    public plansSwiper: any;
    public planDescAfter: string = '/mo price when you upgrade to'; //3 months value should be initialized since it is the default plans
    public planDescAfterSndLine: string = 'the 12-month plan!';
    public planDescBefore: string = 'Lock in the ';
    public activeSlideIndex = 1;
    public animationState = 'in';
    public info: {
        brand: string;
        maxNumberOflines?: number;
        discountsLink: string;
        network: string;
        networkManagementLink: string;
        privacyPolicyLink: string;
        websiteLink: string;
        websiteNumber: string;
        showFullTitle: boolean;
        maskUnlimitedWithGB: boolean;
    };
    public loadingIdentifiers = false;
    public productPlansInfo: Array<IProductPlanInfo>= [];
    public slides: any;
    public subscriptionPlans: MobilePlanItem[];

    private allBasePlans: Array<MobilePlanItem>;
    private alive = true;


    constructor(
        private analyticsService: ActionsAnalyticsService,
        private router: Router,
        private route: ActivatedRoute,
        private mobilePlansService: MobileCustomPlansServiceNoSync,
        private contentfulService: ContentfulService,
        private cdr: ChangeDetectorRef,
        private productPlanService: ProductPlansService,
        private toastHelper: ToastrHelperService) {
        this.mobilePlansService.isConfigurationReady.pipe(takeWhile(() => this.alive)).subscribe((isReady) => {
            if (isReady) {
                this.allBasePlans = this.mobilePlansService?.allBasePlans;
                this.filteredPlans = this.allBasePlans?.filter((plan) => !!plan.parentId && !!plan.subscriptionCycles);
                this.filteredPlans?.sort((a, b) => a?.details?.data - b?.details?.data);
                this.subscriptionPlans = this.filteredPlans?.filter((plan) => plan?.subscriptionCycles === this.selectedSubscription);
                this.getUniquePlanIdentifier();
                this.subscriptionPlans?.sort((a,b) => a?.price - b?.price);
                const unlimitedIndex = this.subscriptionPlans?.findIndex((plan) => plan?.category === 'Unlimited');
                if (unlimitedIndex !== -1) {
                    const [unlimitedPlan] = this.subscriptionPlans?.splice(unlimitedIndex, 1);
                    this.subscriptionPlans.push(unlimitedPlan);
                  }
                this.monthlyPlans = this.filteredPlans?.filter((plan) => plan.subscriptionCycles === 1);
                this.quarterlyPlans = this.filteredPlans?.filter((plan) => plan.subscriptionCycles === 3);
                this.halfYearPlans = this.filteredPlans?.filter((plan) => plan.subscriptionCycles === 6);
                this.yearlyPlans = this.filteredPlans?.filter((plan) => plan.subscriptionCycles === 12);
                if (!!this.monthlyPlans) {
                    this.trackImpressions(this.monthlyPlans);
                }
                this.trackItemsListEvent();
            }
        });
    }

    ngOnInit(): void {
        this.info = {
            brand: BRAND,
            discountsLink: `${WEBSITE_URL}/${SUPPORT_ROUTE_URLS.NAME}/${SUPPORT_ROUTE_URLS.SWITCH_AND_SAVE}`,
            network: 'att',
            networkManagementLink: `${WEBSITE_URL}/${SUPPORT_ROUTE_URLS.NAME}/${SUPPORT_ROUTE_URLS.TERMS_AND_CONDITIONS}/${TERMS_AND_CONDITIONS_ROUTE_URLS.OPEN_INTERNET}`,
            privacyPolicyLink: `${WEBSITE_URL}/${SUPPORT_ROUTE_URLS.NAME}/${SUPPORT_ROUTE_URLS.TERMS_AND_CONDITIONS}/${TERMS_AND_CONDITIONS_ROUTE_URLS.PRIVACY_NOTICE}`,
            websiteLink: `${WEBSITE_URL}`,
            websiteNumber: (new PhonePipe()).transform(CUSTOMER_CARE_NUMBER),
            showFullTitle: true,
            maskUnlimitedWithGB: true
        }
        this.route.params.pipe(takeWhile(() => this.alive)).subscribe(params => {
            if (!!params[SHOP_ROUTE_URLS.PARAMS.SELECTED_TAB]) {
                this.expandPlans = params[SHOP_ROUTE_URLS.PARAMS.IS_EXPAND];
            }
        });
        this.innerWidth = document.documentElement.clientWidth;
        this.contentfulService.getTestimonialsByPageId('testimonials', 'plans').subscribe((socialSwiperSlides) => {
            this.slides = socialSwiperSlides;
        });
        this.cdr.detectChanges();
        this.createTestimonialSwiper();
        this.cdr.detectChanges();
        this.createPlansSwiper();
    }

    ngOnDestroy(): void {
        this.alive = false;
    }
    ngAfterViewInit() {
        this.cdr.detectChanges();
        const TBSmonth = this.route.snapshot.queryParams['month'];// to be selected month
        if (!!TBSmonth)
            this.selectSubscription(Number(TBSmonth));
        setTimeout(() => {
            this.createPlansSwiper();
        }, 100);
    }
    public getUniquePlanIdentifier(): void {
        this.loadingIdentifiers = true;
        this.productPlanService.getPlanUniqueIdentifier().then(res=> {
          if(!!res) {
            this.productPlansInfo = res?.plans;
            this.filteredPlans?.map(plan => {
              const matchingBundle = this.productPlansInfo.find(bundle => bundle?.rate_plan === plan?.bundleId);
              if (matchingBundle) {
                plan.uniquePlanIdentifier = matchingBundle?.id_long;
              }
              return plan;
            });
            this.loadingIdentifiers = false;
          }
        }, error => {
          this.loadingIdentifiers = false;
          this.toastHelper.showAlert(error?.error?.errors[0]?.message || error?.error?.message || error?.message);
        })
      }
    public goToHowITWorks(): void {
      this.router.navigate([`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.SWITCH_AND_SAVE}`])
    }
    public goToWebsite(): void {
        this.router.navigate([ROUTE_URLS.HOME]);
    }
    public goToPrivacyPolicy(): void {
        this.router.navigate([`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.TERMS_AND_CONDITIONS}/${TERMS_AND_CONDITIONS_ROUTE_URLS.PRIVACY_NOTICE}`]);

    }
    public goToNetworkManagement(): void {
        this.router.navigate([`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.TERMS_AND_CONDITIONS}/${TERMS_AND_CONDITIONS_ROUTE_URLS.OPEN_INTERNET}`]);

    }
    public selectSubscription(item): void {
        this.selectedSubscription = item;
        this.subscriptionPlans = [];
        this.subscriptionPlans = this.filteredPlans?.filter((plan) => plan.subscriptionCycles === this.selectedSubscription)
        this.subscriptionPlans.sort((a,b) => a?.price - b?.price);
        const unlimitedIndex = this.subscriptionPlans.findIndex((plan) => plan?.category === 'Unlimited');
         if (unlimitedIndex !== -1) {
             const [unlimitedPlan] = this.subscriptionPlans.splice(unlimitedIndex, 1);
            this.subscriptionPlans.push(unlimitedPlan);
         }
        if (this.selectedSubscription === SUBSCIPTION_DURATIONS.ONE_MONTH) {
            this.planDescAfter = 'for one month of service';
            this.planDescAfterSndLine = '';
            this.planDescBefore = '';
            this.plansConfig.initialSlide = 2;
            this.activeSlideIndex = 2;
            this.cdr.detectChanges();
        } else if (this.selectedSubscription === SUBSCIPTION_DURATIONS.THREE_MONTHS) {
            this.planDescBefore = 'Lock in the ';
            this.planDescAfter = '/mo price when you upgrade to';
            this.planDescAfterSndLine = 'the 12-month plan!';
            this.plansConfig.initialSlide = 1;
            this.activeSlideIndex = 1;
            this.cdr.detectChanges();
        } else if (this.selectedSubscription === SUBSCIPTION_DURATIONS.SIX_MONTHS) {
            this.planDescBefore = 'Lock in the ';
            this.planDescAfter = '/mo price when you upgrade to';
            this.planDescAfterSndLine = 'the 12-month plan!';
            this.plansConfig.initialSlide = 1;
            this.activeSlideIndex = 1;
            this.cdr.detectChanges();
        } else if (this.selectedSubscription === SUBSCIPTION_DURATIONS.ONE_YEAR) {
            this.planDescAfter = 'for one year of service';
            this.planDescBefore = '';
            this.planDescAfterSndLine = '';
            this.plansConfig.initialSlide = 1;
            this.activeSlideIndex = 1;
            this.cdr.detectChanges();
        }
        this.animationState = 'out';
        this.cdr.detectChanges();
        this.createPlansSwiper();
    }

    public createPlansSwiper(): void {
        this.plansSwiper = new Swiper('.plans-swiper-container', {
            hashNavigation: true,
            modules: [Navigation, Pagination, Keyboard],
            ...this.plansConfig,
        });
        this.cdr.detectChanges();
        setTimeout(() => {
            this.plansSwiper.on('slideChange', () => {
                this.activeSlideIndex = this.plansSwiper?.activeIndex;
            });
        }, 200);
        this.cdr.detectChanges();
    }

    public createTestimonialSwiper(): void {
        const testimonialSwiper = new Swiper('.testimonial-swiper-container', {
            hashNavigation: true,
            modules: [Navigation, Pagination, EffectFade, Keyboard],
            ...this.testimonialsConfig
        });
        this.cdr.detectChanges();
    }

    public togglePlansView(): void {
        this.expandPlans = !this.expandPlans;
        if (!!this.expandPlans) {
            const plansViewed = this.halfYearPlans.concat(this.yearlyPlans);
            this.trackImpressions(plansViewed);
        }
    }
    public trackImpressions(plans): void {
        this.analyticsService.trackProductsImpressions(plans, 'Plans-list');
    }
    public goToPlanDetails(planId): void {
        this.router.navigate([`${SHOP_ROUTE_URLS.BASE}${PLANS_SHOP_ROUTE_URLS.BASE}/${PLANS_SHOP_ROUTE_URLS.DETAILS}`, planId]);
    }

    public addParentPlan(id): void {
        const parentPlan = this.yearlyPlans.find((plan) => plan.id === id);
        this.addPlanToCart.emit(parentPlan);
    }

    private trackItemsListEvent(): void {
        let data = {
            event: 'view_item_list',
            ecommerce: {
                item_list_id: "freeup_plans",
                item_list_name: "Freeup Plans",
                items: []
            }
        }
        this.filteredPlans.map((p) => {
            data.ecommerce.items.push({ item_id: p.id, item_name: p.title, affiliation: 'FreeUp Mobile', item_category: 'Plan', price: p.price * p.subscriptionCycles, quantity: 1 })
        });
        this.analyticsService.trackGAEvent(data);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event): void {
        this.innerWidth = document.documentElement.clientWidth;
        this.createPlansSwiper();
    }
}

